module.exports = __webpack_public_path__ + "static/media/logo.22e0ee8e.gltf";